// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import Icon from "../atoms/Icon";
import LinkHandler from "../atoms/LinkHandler";
import { ReactComponent as SocialSymbol } from "../../../assets/images/social-media-symbol.svg";
import { ReactComponent as SportsSymbol } from "../../../assets/images/sports-symbol.svg";

type PropsType = {
    type: string,
    title: string,
};

const SocialLink = (props: {
    url: string,
    name: string,
    type: string,
}): React.Node => {
    const classList = ["social-media-feed__social-link"];

    if (props.type === "sports") {
        classList.push(`social-media-feed__social-link--sports`);
    }

    return (
        <LinkHandler
            to={props.url}
            target="blank"
            className={classList.join(" ")}
        >
            <span className="social-media-feed__social-link__icon">
                <Icon name={props.name.toLowerCase()} />
            </span>
            {props.name}
            <span className="social-media-feed__social-link__icon">
                <Icon name="external-link" />
            </span>
        </LinkHandler>
    );
};

const SocialMediaFeed = (props: PropsType): React.Node => {
    // Social Media Feed
    const socialMediaLinks = useSelector((state: any): any => {
        return props.type === "sports"
            ? state.options.sports_social_links
            : state.options.social_media_links;
    });
    const elfsightAppId = useSelector((state: any): any => {
        return state.options.elfsight_app_id
            ? state.options.elfsight_app_id[props.type]
            : null;
    });

    if (elfsightAppId) {
        return (
            <div className="social-media-feed">
                <div className="social-media-feed__symbol-container">
                    {props.type === "sports" ? (
                        <SportsSymbol />
                    ) : (
                        <SocialSymbol />
                    )}
                </div>
                <div className="container">
                    <div className="social-media-feed__top-content">
                        <h1 className="social-media-feed__heading">
                            {props.title}
                        </h1>
                        <div className="social-media-feed__right-content">
                            <SocialLink
                                url={socialMediaLinks.instagram.url}
                                name="Instagram"
                                type={props.type}
                            />
                            <SocialLink
                                url={socialMediaLinks.facebook.url}
                                name="Facebook"
                                type={props.type}
                            />
                        </div>
                    </div>
                </div>

                <div className="container-fluid container-fluid--bleed-right">
                    <div className="social-media-feed__bottom-content">
                        <div className={elfsightAppId}></div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default SocialMediaFeed;
